import React from "react";
import 'antd/dist/antd.css';
import { Button, Divider, Card } from "antd";
import { ClockCircleOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Row, Col, } from "antd";
import { BACKEND_URL } from "../../../services/backendURL";
import "react-multi-carousel/lib/styles.css";
import moment from "moment";
import AvatarProfile from "../../../helpers/AvatarProfile";



const truncate = (str) => {
    return str.length > 50 ? str.substring(0, 50) + "..." : str;
};

const truncateDescription = (str) => {
    return str.length > 100 ? str.substring(0, 100) + "..." : str;
};



const ConsultNewsComponent = ({ dispatch, items, item, changeIndexVisibility }) => {
    const currentNewsId = item.id;
    const otherItems = items.filter((elm) => elm.id !== currentNewsId).slice(0, 4);


    const startInfoItem = (item) => {
        const action = {
            type: "open_consult_view",
            payload: {
                item: item,
                indexVisibility: 1
            }
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card>
                            <Row gutter={24} align="middle">
                                <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
                                <Col xl={16} lg={16} md={0} sm={0} xs={0} className="text-center">
                                    <h3 className="m-0 p-0">Jeni duke konsultuar lajmin e zgjedhur</h3>
                                </Col>
                                <Col xl={4} lg={4} md={0} sm={0} xs={0} className="text-right">
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => changeIndexVisibility(0)}
                                        icon={<ArrowLeftOutlined />}
                                        size="large"
                                    >
                                        Kthehu
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card className="mt-2">
                            <Row gutter={24}>
                                <Col xl={2} lg={2} md={24} sm={24} xs={24} className="text-right"></Col>
                                <Col xl={20} lg={20} md={24} sm={24} xs={24}>
                                    <Row gutter={24}>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <b><h4 className="mt-2">{item?.title}</h4></b>
                                        </Col>
                                    </Row>
                                    <Row gutter={24} align="middle">
                                        <Col xl={12} lg={12} md={24} sm={24} xs={24} className="text-left">
                                            <ClockCircleOutlined className="h-100" /> &nbsp;<span style={{ fontSize: '13px', marginTop: '5px' }}>{moment(item.publish_date === 'undefined' ? '' : item.publish_date).format("DD/MM/YYYY HH:mm")}, &nbsp; publikuar nga {item.member.name + " " + item.member.surname} </span>
                                        </Col>
                                    </Row>
                                    < Divider style={{ backgroundColor: "lightgrey" }} className="mb-1" />
                                    <Row gutter={24} className='mt-4'>
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <img style={{ width: "100%" }} src={BACKEND_URL + item.photo} alt="News Logo" />
                                        </Col>
                                    </Row>
                                    <Row gutter={24} className="m-2">
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <p className="m-0 mt-2 mb-2 p-0">{item?.content}</p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xl={2} lg={2} md={24} sm={24} xs={24} className="text-left"></Col>
                            </Row>
                        </Card>
                        <Card className="mt-2">
                            <Row gutter={24}>
                                <Col span={24}>
                                    <Divider orientation="left" style={{ borderTopColor: "#a461d852" }} className="m-0">
                                        <h5 className="m-0" style={{ color: "#a461d8" }}>Lajmet e fundit</h5>
                                    </Divider>
                                </Col>
                            </Row>
                            <Row gutter={24} className='mt-2'>

                                {otherItems.map((elm, index) => (
                                    <>
                                        <Col xl={6} lg={6} md={24} sm={24} xs={24} className="mt-2">
                                            <Card
                                                hoverable
                                                bodyStyle={{ padding: "0" }}
                                                // style={{ border: "none" }}
                                                onClick={() => startInfoItem(elm)}
                                            >
                                                <Row gutter={24} align="middle" style={{ padding: "10px" }}>
                                                    <Col xl={16} lg={16} md={16} sm={16} xs={16}>
                                                        <AvatarProfile
                                                            photo={elm.member.photo}
                                                            name={elm.member.name}
                                                            surname={elm.member.surname}
                                                            fullName={elm.member.name + " " + elm.member.surname}
                                                        />
                                                    </Col>
                                                    <Col xl={8} lg={8} md={8} sm={8} xs={8} className="text-right">
                                                        {moment(elm.publish_date === 'undefined' ? '' : elm.publish_date).format("DD/MM/YYYY")}
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} className="m-1">
                                                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <b><h5>{truncate(elm?.title === 'undefined' ? '' : elm?.title)}</h5></b>
                                                        <p className="m-0 mb-2 p-0">{truncateDescription(elm?.content === 'undefined' ? '' : elm?.content)}</p>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </>
                                ))}

                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default ConsultNewsComponent;